import { render, staticRenderFns } from "./mobileLayout.vue?vue&type=template&id=4b17db34&scoped=true"
import script from "./mobileLayout.vue?vue&type=script&lang=js"
export * from "./mobileLayout.vue?vue&type=script&lang=js"
import style0 from "./mobileLayout.vue?vue&type=style&index=0&id=4b17db34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b17db34",
  null
  
)

export default component.exports